namespace Matrix.Data {

    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountValuesDialog extends Serenity.TemplatedDialog<any> {

        public grid: AccountValuesGrid;

        constructor() {
            super();

            this.grid = new AccountValuesGrid(this.element.children());
        }

        protected getTemplate() {
            return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}